import React, { useMemo } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import Input from 'components/atoms/input';
import { useSelector } from 'react-redux';

const ParentClinic = ({ errors, agencyGuid, isLoading }) => {
  const clinics = useSelector((state) => state.adminPanelClinics.data);
  const currentClinic = useSelector((state) => state.adminPanelClinics.clinic);
  const filteredClinics = useMemo(
    () =>
      clinics
        .filter(
          (clinic) =>
            clinic?.agency?.guid === agencyGuid &&
            clinic.guid !== currentClinic.guid,
        )
        .map(({ guid, legalname }) => ({
          id: guid,
          label: legalname,
        })),
    [agencyGuid, clinics],
  );
  const clinicOptions = [{ id: null, label: 'None' }, ...filteredClinics];

  return (
    <div className="admin-patient-form-block">
      <span>Parent Clinic</span>
      <Row>
        <Col lg="12" md="12" sm="12" xs="12">
          <Input
            label="Parent Clinic"
            id="parentClinicGuid"
            type="select"
            disabled={isLoading || currentClinic?.childClinics?.length > 0}
            isMulti={false}
            options={clinicOptions}
          />
          {errors.parentClinicGuid ? (
            <div className="input-error">{errors.parentClinicGuid}</div>
          ) : null}
        </Col>
      </Row>
    </div>
  );
};

ParentClinic.defaultProps = {
  isLoading: false,
};

ParentClinic.propTypes = {
  errors: PropTypes.shape({
    parentClinicGuid: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool,
  agencyGuid: PropTypes.string,
};

export default ParentClinic;
